import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1621188"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "no-mb"
}

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { EyeOutlined } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessagesWidget',
  setup(__props) {

const router = useRouter()
const loading = ref(false)
const messages = ref([])

onMounted(() => {
  getMessages()
})

function getMessages () {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL_V2 + '/messages').then((r) => {
    messages.value = r.data.data
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Berichten",
    loading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { class: "no-mb" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              (messages.value.length)
                ? (_openBlock(), _createBlock(_component_a_list, {
                    key: 0,
                    "data-source": messages.value,
                    "item-layout": "horizontal",
                    pagination: false
                  }, {
                    renderItem: _withCtx(({ item }) => [
                      _createVNode(_component_a_list_item, {
                        onClick: ($event: any) => (_unref(router).push({ name: 'MessageDetails', params: { messageId: item.id.toString() } }))
                      }, {
                        actions: _withCtx(() => [
                          _createVNode(_component_a_button, { size: "small" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(EyeOutlined))
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_list_item_meta, null, {
                            title: _withCtx(() => [
                              (!item.read_at || item.new_reaction)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 0,
                                    title: "Nieuw bericht",
                                    placement: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_badge, {
                                        color: "#f38929",
                                        dot: ""
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(item.title), 1)
                            ]),
                            description: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.created_ago), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["data-source"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_1, "Er zijn (nog) geen berichten voor u."))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})